/* eslint-disable no-console */
import React from "react";
import { useSelector } from "react-redux";
import { AdminPageBody } from "../../../layout/AdminPage/AdminPageBody";
import { PickUpLocationList as PickUpLocationListMole } from "../../molecules";
import { PickUpLocationWrapper } from "./PickUpLocation.style";
import { PickUpLocationListToolbar } from "./PickUpLocationListToolbar";

export const PickUpLocationList: React.FC = () => {
  const { pickUpLocations } = useSelector(
    (state: any) => state.pickUpLocations
  );
  const { loading } = useSelector((state: any) => state.async);
  const [searchName, setSearchName] = React.useState("");
  const filteredPickUpLocations = React.useMemo(() => {
    const query = searchName.trim().toLowerCase();
    if (!query) return pickUpLocations;
    return pickUpLocations.filter((location: any) =>
      (location.name || "").toLowerCase().includes(query)
    );
  }, [pickUpLocations, searchName]);
  return (
    <AdminPageBody
      pageToolbar={
        <PickUpLocationListToolbar
          searchName={searchName}
          onSearchNameChange={setSearchName}
        />
      }
    >
      <PickUpLocationWrapper>
        <PickUpLocationListMole
          pickUpLocations={filteredPickUpLocations}
          loading={loading}
        />
      </PickUpLocationWrapper>
    </AdminPageBody>
  );
};
